import { FaAws, FaDocker, FaPython, FaGithub } from 'react-icons/fa6';
import { SiKubernetes, SiPostgresql, SiRedis, SiElasticsearch, SiTypescript, SiGo, SiMysql, SiGrafana } from 'react-icons/si';

export const metrics = [
  { label: "Years Scaling FinTech", value: "8+"},
  { label: "Robust Systems Deployed", value: "10+"},
  { label: "Users", value: "50,000+" },
  { label: "Transactions Processed", value: "₦4B+ / $5M+" },
  { label: "Infrastructure Uptime", value: "99.99%" },
  { label: "Engineers Led", value: "100+" },
];

export const systems = [
  {
    title: "Multi-Currency Financial Platform",
    points: [
      "Dual-ledger system (USD, NGN, CAD, GBP)",
      "Real-time transaction processing",
      "FX engine + escrow settlement",
    ],
  },
  {
    title: "KYC & Fraud Detection System",
    points: [
      "Identity verification pipelines",
      "Transaction monitoring",
      "Real-time risk scoring",
    ],
  },
  {
    title: "Microservices Infrastructure",
    points: [
      "Kubernetes-based architecture",
      "Fault isolation and scaling",
      "Observability and incident handling",
    ],
  },
];

export const partners = [
  { name: 'AWS', icon: FaAws },
  { name: 'Kubernetes', icon: SiKubernetes },
  { name: 'Docker', icon: FaDocker },
  { name: 'GoLang', icon: SiGo },
  { name: 'TypeScript', icon: SiTypescript },
  { name: 'Python', icon: FaPython },
  { name: 'MySQL', icon: SiMysql },
  { name: 'PostgreSQL', icon: SiPostgresql },
  { name: 'Redis', icon: SiRedis },
  { name: 'Elasticsearch', icon: SiElasticsearch },
  { name: 'GitHub', icon: FaGithub },
  { name: 'Grafana', icon: SiGrafana },
];

export const expertise = [
  'Distributed Systems',
  'Microservices Architecture',
  'FinTech Infrastructure',
  'High-Throughput Processing',
  'Regulatory Compliance (AML/KYC)',
  'Event-Driven Systems',
  'Global Payments Integration',
  'Engineering Leadership'
];

export const experiences = [
  {
    role: 'Chief Technology Officer',
    company: 'Cashwise Finance',
    type: 'Executive Leadership',
    achievements: [
      'Scaled and operated a production fintech platform serving 15,000+ users, processing $15M+ in volume with 99.999% uptime.',
      'Owned end-to-end system architecture, delivering a multi-entity, multi-currency dual-ledger infrastructure ensuring auditability.',
      'Architected and deployed a cloud-native microservices platform (Docker + Kubernetes) for independent service scaling.',
      'Designed real-time transaction processing systems with strong consistency guarantees and an automated FX rate engine.',
      'Built and led a cross-functional team of 25+ engineers across backend, frontend, and DevOps.',
      'Established engineering structures, hiring pipelines, and performance management systems from the ground up.',
      'Developed and enforced IT policies and procedures to ensure strict adherence to security and compliance standards.'
    ]
  },
  {
    role: 'Chief Solution Specialist',
    company: 'Yoak Solutions Limited',
    type: 'Strategic Consulting',
    achievements: [
      'Spearheaded the development and implementation of mobile apps, websites, integrated systems, and internal control dashboards.',
      'Led the architecture of a cloud-based platform that significantly reduced operational costs while improving client experience.',
      'Implemented and oversaw an enterprise-wide security strategy that increased data protection and minimized systemic risks.',
      'Created and managed technology budgets that improved resource allocation.',
      'Developed a complex data warehouse solution enabling real-time analysis and reporting of key business metrics.'
    ]
  },
  {
    role: 'Chief Technology Officer',
    company: 'Avivwallet (avivpay)',
    type: 'Leadership & Architecture',
    achievements: [
      'Defined engineering processes, CI/CD pipelines, and deployment strategies, reducing release cycles from 1 day to under 10 minutes.',
      'Designed disaster recovery and failover systems ensuring business continuity during outages.',
      'Led incident response protocols and resolved critical scaling bottlenecks under production load.',
      'Optimized system performance, reducing web request response times by 30%.',
      'Defined strong engineering culture, coding standards, and rigorous code review processes.',
      'Led a team of developers to successfully complete a major software project on time and strictly within budget.'
    ]
  },
  {
    role: 'Software Consultant',
    company: 'Avivwallet (avivpay)',
    type: 'Engineering',
    achievements: [
      'Developed a reusable library of components that reduced frontend development time by 40%.',
      'Implemented a modern design system that improved user experience and increased engagement by over 20%.',
      'Developed a custom CMS enabling non-technical users to seamlessly update platform content.',
      'Engineered a comprehensive compliance program that reduced the risk of non-compliance by 60%.'
    ]
  },
  {
    role: 'Engineering Lead',
    company: 'PennyTree Business Limited',
    type: 'Management',
    achievements: [
      'Stabilized infrastructure to successfully scale the user base by 1900% (from 1,000 to 19,000) with zero extra infrastructure cost.',
      'Led the structural transition of PennyTree\'s technology from a monolithic backend to a microservices architecture.',
      'Architected and implemented sticky gamification features like Save and Pay, augmenting core financial loops.',
      'Coordinated the strategic transition from shared hosting to a highly-available cloud-based application.',
      'Conducted in-depth analyses of technological performance versus direct business goals to drive system efficiency.'
    ]
  },
  {
    role: 'Compliance/Risk Analyst & Developer',
    company: 'Capital Metriq Swift Microfinance',
    type: 'Engineering & Compliance',
    achievements: [
      'Spearheaded AML/KYC initiatives, significantly streamlining customer onboarding and real-time transaction monitoring.',
      'Conducted thorough risk and vulnerability assessments to mitigate potential security threats and compliance gaps.',
      'Implemented secure coding practices and conducted code reviews to ensure system integrity and application security.',
      'Supported the business with designing and launching new features while ensuring absolute legal and regulatory compliance.',
      'Collaborated directly with the Chief Compliance Officer to align technical infrastructure with evolving financial crime regulations.'
    ]
  }
];

export const insightsData = [
  {
    id: "1",
    title: "The Future of Cloud Computing in Africa",
    excerpt: "Exploring how cloud adoption is transforming businesses across the continent and the opportunities it presents for economic growth.",
    date: "March 15, 2024",
    readTime: "5 min read",
    views: "2.3k",
    category: "Cloud Technology",
    imageUrl: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: "2",
    title: "Digital Transformation Strategies for SMEs",
    excerpt: "A comprehensive guide to implementing digital transformation initiatives in small and medium enterprises with limited budgets.",
    date: "March 8, 2024",
    readTime: "8 min read",
    views: "1.8k",
    category: "Business Strategy",
    imageUrl: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: "3",
    title: "Cybersecurity Best Practices for African Businesses",
    excerpt: "Essential cybersecurity frameworks and practices that African businesses should implement to protect their digital assets.",
    date: "February 28, 2024",
    readTime: "6 min read",
    views: "3.1k",
    category: "Cybersecurity",
    imageUrl: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: "4",
    title: "The Role of AI in Modern Business Operations",
    excerpt: "How artificial intelligence is revolutionizing business processes and what leaders need to know about AI implementation.",
    date: "February 20, 2024",
    readTime: "7 min read",
    views: "2.7k",
    category: "Artificial Intelligence",
    imageUrl: "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: "5",
    title: "Architecting Microservices for Fintech Platforms",
    excerpt: "A deep dive into decomposing monolithic banking systems into scalable, highly-available microservices using event-driven architectures.",
    date: "February 10, 2024",
    readTime: "12 min read",
    views: "4.5k",
    category: "Engineering Leadership",
    imageUrl: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: "6",
    title: "Scaling Engineering Teams in Remote Environments",
    excerpt: "Practical frameworks for maintaining high velocity, strong culture, and rigorous code quality across distributed engineering hubs.",
    date: "January 28, 2024",
    readTime: "6 min read",
    views: "3.9k",
    category: "Business Strategy",
    imageUrl: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: "7",
    title: "AML/KYC Compliance as Code",
    excerpt: "Integrating regulatory requirements directly into CI/CD pipelines and infrastructure deployments to automate risk management.",
    date: "January 15, 2024",
    readTime: "9 min read",
    views: "2.1k",
    category: "Cybersecurity",
    imageUrl: "https://images.unsplash.com/photo-1563986768609-322da13575f3?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: "8",
    title: "High-Throughput Payment Gateways",
    excerpt: "Technical lessons learned from scaling digital wallets to handle thousands of concurrent transactions under load.",
    date: "January 2, 2024",
    readTime: "15 min read",
    views: "5.2k",
    category: "Cloud Technology",
    imageUrl: "https://images.unsplash.com/photo-1614064641913-a442e94b29bb?q=80&w=800&auto=format&fit=crop"
  }
];